import { render } from "./AboutVideo.vue?vue&type=template&id=37e86f24&scoped=true"
import script from "./AboutVideo.vue?vue&type=script&lang=js"
export * from "./AboutVideo.vue?vue&type=script&lang=js"

import "./AboutVideo.vue?vue&type=style&index=0&id=37e86f24&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e86f24"]])

export default __exports__